import * as React from 'react'
import Select from 'react-select'
import { mapCurrencyToName, mapCurrencyToSymbol } from './currencyMapping'
import { captureExceptionWithSentry } from '../sentry'
import apiFetch from '../common/apiFetch'
import { customStylesForPulldowns } from './components/filters/customStyles'

interface CurrencySelectProps {
	id?: string
	currency: string
	currencyChanged: (newCurrency: string, conversionRate: number) => void
	noApi?: boolean
}

interface Currency {
	symbol: string
	rate: string
}

interface CurrencySelectState {
	currencies: Currency[]
}

const customStylesForSelect = {
	...customStylesForPulldowns,
	container: (provided: any) => ({
		...provided,
		width: '100%',
	}),
}

const CURRENCIES = [
	{
		symbol: 'CHF',
		rate: '1',
	},
	{
		symbol: 'DKK',
		rate: '1',
	},
	{
		symbol: 'EUR',
		rate: '1',
	},
	{
		symbol: 'GBP',
		rate: '1',
	},
	{
		symbol: 'NOK',
		rate: '1',
	},
	{
		symbol: 'SEK',
		rate: '1',
	},
	{
		symbol: 'USD',
		rate: '1',
	},
] as Currency[]

class CurrencySelect extends React.Component<CurrencySelectProps, CurrencySelectState> {
	public constructor(props: CurrencySelectProps) {
		super(props)
		this.state = { currencies: [] }
	}

	public async componentDidMount() {
		try {
			if (this.props.noApi) {
				this.setState({ currencies: CURRENCIES })
			} else {
				const res = await apiFetch('/currencies', { method: 'GET' })
				const value = await res.json()
				const currencies = (value?.data as Currency[]) ?? []
				this.setState({ currencies })
			}
		} catch (error) {
			captureExceptionWithSentry(error)
		}
	}

	public componentDidUpdate(prevProps: CurrencySelectProps) {
		if (this.props.currency !== prevProps.currency) {
			const currencyItem = this.state.currencies.find((cur) => cur.symbol === this.props.currency)
			if (currencyItem) {
				this.props.currencyChanged(this.props.currency, +currencyItem.rate)
			}
		}
	}

	private getLabel(currency: string) {
		return `${mapCurrencyToName(currency)} (${mapCurrencyToSymbol(currency)})`
	}

	public render() {
		return (
			<div data-testid="currencySelect">
				<Select
					classNamePrefix="currency-select"
					inputId={this.props.id}
					styles={customStylesForSelect}
					placeholder="Select a currency"
					menuPlacement="auto"
					value={{ label: this.getLabel(this.props.currency), value: this.props.currency }}
					options={this.state.currencies.map((item) => {
						return {
							label: this.getLabel(item.symbol),
							value: item.symbol,
						}
					})}
					onChange={(value: any) => {
						if (value) {
							this.props.currencyChanged(
								value.value,
								+this.state.currencies.find((cur) => cur.symbol === value.value)!.rate,
							)
						}
					}}
					components={{ DropdownIndicator: () => null, IndicatorSeparator: () => null }}
				/>
			</div>
		)
	}
}

export default CurrencySelect
